import { OrderStatus } from "./IOrder"

export interface ICustomerSettings{
    id?: number
    isShowPushNotification?: boolean
    isNotDisturbMode?:boolean
    notificationSchedule?: INotificationSchedule
    depotsIds?: number[]
    fuelTypesIds?: number[]
    notificationSettings?: ICustomerNotificaitonSettings[]
}

export interface ICustomerNotificaitonSettings{
    id: number
    settingsId: number
    statusText: string
    settingType: NotificationSettingType
    status?: OrderStatus
    isEmailNotificationEnable: boolean
    isPushNotificationEnable: boolean
    isVoceEnable: boolean
    isImportant: boolean
    children?: ICustomerNotificaitonSettings[]
}

export interface INotificationSchedule{
    id: number
    from: string
    to: string
    isOnlyImportantNotification?: boolean
    customerSettingsId: number
    notificationDays: number[]
}

export interface IUpdateCustomerNotificationTypeEnable{
    CustomerNotificationSettingsId: number
    isEmailNotificationEnable: boolean
    isPushNotificationEnable: boolean
}

export interface IUpdateCusotmerSettings{
    settingsId: number
    depotIds?: number[]
    fuelTypeIds?: number[]
}

export enum NotificationSettingType{
    OrderStatus,
    PricesLimits,
    System,
    Information
}

export enum DayOfWeek{
    Sunday,
    Monday,
    Tuesday,
    Wednesday,
    Thursday,
    Friday,
    Saturday
}